import { render, staticRenderFns } from "./empowerment.vue?vue&type=template&id=3b6c417a&scoped=true&"
import script from "./empowerment.vue?vue&type=script&lang=ts&"
export * from "./empowerment.vue?vue&type=script&lang=ts&"
import style0 from "./empowerment.vue?vue&type=style&index=0&id=3b6c417a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c417a",
  null
  
)

export default component.exports